export default "__VITE_ASSET__CL015qrI__"